
import { AxiosTeenus } from './axios-teenus';
import { UldkasulikToo } from '@/models/UldkasulikToo';

export class UldkasilikTooTeenus {

    public async minuUldkasulikTooInfo(): Promise<UldkasulikToo[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<UldkasulikToo[]>(`/api/uldkasuliktoo/uktalused`);

        return response?.data;
    }
}